/**
 * @name THEME_DEVICE_NAMES
 * @description device names
 */
export const THEME_DEVICE_NAMES = {
  DESKTOP: 'desktop',
  TABLET: 'tablet',
  MOBILE: 'mobile',
};
